import { useMemo } from 'react';
import { works } from '@/mocks/animeWorks';

export default function Ranking() {
  const list = useMemo(
    () => [...works].sort((a, b) => b.rating - a.rating).slice(0, 6),
    []
  );

  return (
    <section id="ranking" className="scroll-mt-16 bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-semibold text-primary-700">
              <i className="ri-trophy-line" />
              本站口碑
            </span>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              人气排行榜
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              根据站内评分与追更热度整理，上榜作品是漫迷们反复推荐的口碑之选。
            </p>
          </div>
        </div>

        <ol className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((work, index) => (
            <li
              key={work.id}
              className="flex gap-4 rounded-lg bg-background-50 p-3 transition-colors hover:bg-background-200/60"
            >
              <div className="relative shrink-0">
                <img
                  src={work.cover}
                  alt={`${work.title}封面`}
                  title={`${work.title} 恋爱后宫漫画`}
                  className="aspect-[3/4] w-20 rounded-md object-cover sm:w-24"
                />
                <span
                  className={`absolute -left-1.5 -top-1.5 flex h-7 w-7 items-center justify-center rounded-full text-sm font-black text-background-50 ${
                    index === 0
                      ? 'bg-accent-500'
                      : index === 1
                        ? 'bg-primary-500'
                        : 'bg-secondary-500'
                  }`}
                >
                  {index + 1}
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="mb-1 line-clamp-1 text-base font-semibold text-foreground-950">
                  {work.title}
                </h3>
                <div className="mb-2 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                    {work.category}
                  </span>
                  <span>{work.year}</span>
                </div>
                <p className="mb-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {work.desc}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-600">
                  <span className="flex items-center gap-1 text-accent-700">
                    <i className="ri-star-fill" />
                    {work.rating.toFixed(1)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-book-open-line" />
                    {work.chapters}话
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}